export default __webpack_public_path__ + "static/media/location.510a9c2b.svg";